export default "__VITE_ASSET__ByKdYkua__"